<section class="client-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Opinión de Nuestros Clientes</h2>
            <p class="text-justify">En enCloud, nos enorgullece ofrecer soluciones de tecnología de vanguardia y un servicio al cliente excepcional. Pero no tomes solo nuestra palabra. Aquí te compartimos algunas opiniones de nuestros clientes satisfechos:</p>
        </div>
        
        <div class="row">
            <div class="client-wrap owl-carousel owl-theme">
                <div class="single-client">
                    <img src="assets/img/client/client-img-one.jpg" alt="Image">
                    <h3>Juan Pérez, Director de IT</h3>
                    <span>Centro de investigación</span>
                    <p>"Desde que empezamos a trabajar con enCloud, hemos experimentado un notable aumento en la seguridad y eficiencia de nuestros procesos de almacenamiento y procesamiento de datos. Su equipo nos ha brindado soporte de clase mundial, siempre dispuesto a encontrar soluciones innovadoras que se adapten."</p>
                    <ul>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                    </ul>
                </div>

                <div class="single-client">
                    <img src="assets/img/client/client-img-two.jpg" alt="Image">
                    <h3>Ana González, CEO</h3>
                    <span>Empresa de Desarrollo de Software</span>
                    <p>"El servicio de cómputo en la nube de enCloud ha sido clave para el crecimiento de nuestra infraestructura. La disponibilidad de servidores dedicados y la capacidad de personalización nos han permitido escalar nuestros proyectos sin problemas. Además, la atención al cliente es excelente, siempre resolviendo nuestras dudas."</p>
                    <ul>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                    </ul>
                </div>

                <div class="single-client">
                    <img src="assets/img/client/client-img-three.jpg" alt="Image">
                    <h3>Daniel Asunza, CTO</h3>
                    <span>Empresa de Desarrollo de Software</span>
                    <p>"Con enCloud hemos logrado optimizar la gestión de nuestros servidores para videojuegos, lo que ha mejorado la experiencia de nuestros usuarios. La fiabilidad y el alto rendimiento de los servicios de enCloud nos han permitido enfocarnos en el desarrollo de nuevos juegos sin preocuparnos por el lado técnico."</p>
                    <ul>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                    </ul>
                </div>
                
                <div class="single-client">
                    <img src="assets/img/client/client-img-four.jpg" alt="Image">
                    <h3>Marta Ramírez, Directora</h3>
                    <span>Hospital</span>
                    <p>"Trabajar con enCloud ha transformado la forma en que gestionamos nuestros datos y procesos operativos. Su solución de almacenamiento en la nube es altamente confiable y segura, lo que nos permite cumplir con estrictos requisitos regulatorios en el sector de la salud. Además, su equipo de soporte siempre está disponible."</p>
                    <ul>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                        <li><i class="bx bxs-star"></i></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="shape shape-ome">
        <img src="assets/img/shape/client.png" alt="Image">
    </div>
</section>